<route-meta>
{
  "requiresAuth": true,
  "permissions": ["stats"]
}
</route-meta>

<template>
  <div class="charts">
    <h1>This is an charts page</h1>
    <commit-chart></commit-chart>
  </div>
</template>

<script>
import CommitChart from '@/components/charts/CommitChart';

export default {
  name: 'charts',
  components: {
    CommitChart,
  },
  computed: {
    hasPermissions() {
      return this.$store.getters['auth/hasPermissions'](
        this.$route.meta.permissions,
      );
    },
  },
  created() {
    this.$store.dispatch('breadcrumbs/reset');
    console.log(this.$route.meta, this.hasPermissions);
  },
};
</script>
